import { Component, Input } from '@angular/core';
import { DraftAsset } from '@assetaccountant/assets/models/draft-asset';

@Component({
  selector: 'app-draft-asset-list-link-cell',
  templateUrl: './draft-asset-list-link-column.component.html',
  standalone: false,
})
export class DraftAssetListLinkCellComponent {
  @Input() data: DraftAsset;
  @Input() value?: string;
}
